import * as variables from '../variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0; 
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import './lib/StickyHeader';

// ---------------------------------------------------------------------------------------------- //
// Animations
// 
// SEE EXAMPLE BELOW: 
// 
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 50,
// 		minimumUnit: "%"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //
